import { Injectable } from '@angular/core';
import { UserRoleService } from '../../components/user-and-role-management/user-role.service';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from './auth.service';

interface Role {
  id: string;
  name: string;
  description: string;
  permissions: any[];
}

interface Permission {
  id: string;
  name: string;
  description: string;
  module: 0 | 1 | 2 | 3 | 4;
  moduleName: string;
}

interface UserPermissions {
  0: Permission[];
  1: Permission[];
  2: Permission[];
  3: Permission[];
  4: Permission[];
}

interface UserDetails {
  id: string;
  userInfo: {
    roles: Array<{
      id: string;
      name: string;
      description: string;
    }>;
    allowedFeatures: string[];
  };
}

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private userPermissions: UserPermissions = {
    0: [],
    1: [],
    2: [],
    3: [],
    4: [],
  };
  private currentUser = new BehaviorSubject<UserDetails | null>(null);
  currentUser$ = this.currentUser.asObservable();
  userProfile: any;
  constructor(
    private userRoleService: UserRoleService,
    private authService: AuthService
  ) {
    // if (!this.userProfile) this.authService.getUserProfile();

    this.authService.profile$.subscribe((profile: any) => {
      this.userProfile = profile;

      if (this.userProfile?.attributes?.personId[0]) {
        this.loadUserDetails();
      }
    });
  }

  private loadUserDetails(): void {
    if (!this.userProfile) return;
    this.userRoleService
      .getStaffUser(this.userProfile.attributes?.personId[0])
      .subscribe({
        next: (res) => {
          this.currentUser.next(res);
        },
        error: (err) => {
          console.error('Error fetching user details:', err);
        },
      });
  }

  hasPermission(permission: string): boolean {
    const user = this.currentUser.getValue(); // Get the current user synchronously
    if (!user) {
      return false;
    }
    return user.userInfo.allowedFeatures.includes(permission);
  }

  getCurrentUser() {
    return this.currentUser.asObservable();
  }

  hasModulePermission(moduleShortName: string): boolean {
    const user = this.currentUser.getValue();
    if (!user || !user.userInfo || !user.userInfo.allowedFeatures) {
      return false;
    }
    const prefix = `${moduleShortName}-`;
    return user.userInfo.allowedFeatures.some((feature) => {
      if (!feature) return false;
      return feature.startsWith(prefix);
    });
  }
}
